<ng-container *ngIf="(_detailPath | decodeUrl) || { segments: null, queryParams: null } as url">
  <a
    class="rounded-border w-full leading-normal no-underline"
    [ngClass]="{
      'cursor-pointer': _downloadPath
    }"
    [routerLink]="url.segments"
    [queryParams]="url.queryParams"
    (click)="
      isTaskItem && clickTask();
      _downloadPath && $event.preventDefault();
      _downloadPath && $event.stopPropagation();
      _downloadPath && downloadFile({ downloadPath: _downloadPath, name: config.title })
    ">
    <div
      class="pixelgap rounded-border grid grid-cols-12 overflow-hidden border border-gray-400 bg-gray-400"
      [ngClass]="{ 'cardview-new': config.hasNewInfo }">
      <div class="pixelgap col-span-12 flex w-full flex-wrap">
        <ng-container [ngTemplateOutlet]="checkboxComponent"></ng-container>
        <ng-container [ngTemplateOutlet]="taskComponent"></ng-container>
        <ng-container [ngTemplateOutlet]="mainInfoComponent"></ng-container>
        <div
          *ngIf="hasMetaData"
          class="pixelgap flex w-full flex-wrap"
          [ngClass]="{
            'w-auto flex-1':
              !hasToShowMainInfoComponent &&
              !hasToShowStatusComponent &&
              !hasToShowActionsComponent &&
              !hasToShowTaskComponent
          }">
          <ng-container [ngTemplateOutlet]="documentsToggleComponent"></ng-container>
          <div *ngIf="config.documents?.length && showDocumentsList" class="flex w-full md:hidden">
            <ng-container
              [ngTemplateOutletContext]="{ items: config.documents }"
              [ngTemplateOutlet]="documentsList"></ng-container>
          </div>
          <ng-container [ngTemplateOutlet]="openTasksComponent"></ng-container>
          <div *ngIf="config.documents?.length && showDocumentsList" class="hidden w-full md:flex lg:hidden">
            <ng-container
              [ngTemplateOutletContext]="{ items: config.documents }"
              [ngTemplateOutlet]="documentsList"></ng-container>
          </div>
          <ng-container [ngTemplateOutlet]="infoComponent"></ng-container>
          <ng-container [ngTemplateOutlet]="labelsComponent"></ng-container>
          <ng-container [ngTemplateOutlet]="optionalInfoComponent"></ng-container>
          <div *ngIf="config.documents?.length && showDocumentsList" class="hidden w-full lg:flex">
            <ng-container [ngTemplateOutletContext]="{ items: config.documents }" [ngTemplateOutlet]="documentsList">
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </a>
</ng-container>

<ng-template #checkboxComponent>
  <div
    (click)="$event.preventDefault(); $event.stopPropagation(); selectItem({ checked: !config.checked })"
    *ngIf="widgetType?.actions?.length || config.hasCheckbox"
    class="px-2-5 py-2-5 hidden items-start bg-white md:flex">
    <p-checkbox
      (onChange)="$event.originalEvent.stopPropagation(); selectItem($event)"
      [binary]="true"
      [ngModel]="config.checked"></p-checkbox>
  </div>
</ng-template>

<ng-template #taskComponent>
  <div
    *ngIf="!hasToShowTaskComponent && hasToShowStatusComponent && hasToShowActionsComponent"
    class="hidden flex-1 justify-between bg-white px-4 py-2 md:flex lg:hidden">
    <ng-container [ngTemplateOutlet]="statusComponent"></ng-container>
    <div *ngIf="hasToShowActionsComponent" class="flex items-center px-1 lg:hidden">
      <ng-container [ngTemplateOutlet]="actionsComponent"></ng-container>
    </div>
  </div>
  <div
    *ngIf="hasToShowTaskComponent"
    class="flex w-60 flex-1 flex-row justify-between bg-white"
    [ngClass]="{
      'lg:flex-initial': !isHalfWidth,
      'lg:flex-1': isHalfWidth
    }">
    <div
      *ngIf="config.task"
      class="flex flex-1 flex-row flex-wrap items-center gap-x-2 px-4 py-2 lg:flex-col lg:items-start lg:justify-center"
      [ngClass]="{
        'lg:col-span-2': !isHalfWidth
      }"
      [pTooltip]="assignedTooltip"
      [escape]="false"
      tooltipPosition="top"
      style="min-height: 45px">
      <span class="font-bold">{{ config.task.value }}</span>
      <span *ngIf="config.assigned" class="text-xs text-gray-600">
        <i class="fa-solid fa-user-check text-gray-600"></i>
        {{ config.assigned }}
      </span>
    </div>
    <div
      *ngIf="hasToShowStatusComponent"
      class="hidden items-center px-4 md:flex"
      [ngClass]="{
        'lg:hidden': !isHalfWidth,
        'lg:flex': isHalfWidth
      }">
      <ng-container [ngTemplateOutlet]="statusComponent"></ng-container>
    </div>
    <div *ngIf="hasToShowActionsComponent" class="flex items-center px-1 lg:hidden">
      <ng-container [ngTemplateOutlet]="actionsComponent"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #statusComponent>
  <div class="flex max-w-max flex-wrap items-center gap-2 bg-white lg:justify-end">
    <p-tag
      *ngFor="let status of config.status"
      [style]="{
        background: status.color
      }"
      class="flex"
      [pTooltip]="status.name !== status.shortName && status.name"
      styleClass="overflow-hidden whitespace-nowrap"
      tooltipPosition="top">
      <div class="flex items-center gap-2 overflow-hidden">
        <span
          [style]="{
            color: (status.color | lightenDarkenColor) + ' !important'
          }"
          class="overflow-hidden text-ellipsis whitespace-nowrap"
          >{{ status.shortName }}</span
        >
        <i
          [style]="{
            color: (status.color | lightenDarkenColor) + ' !important'
          }"
          class="p-tag-icon"
          [class]="status.icon"></i>
      </div>
    </p-tag>
  </div>
</ng-template>

<ng-template #mainInfoLabelsComponent>
  <div class="inline-flex gap-2 md:flex">
    <span
      *ngIf="config.new"
      class="rounded-border h-1-5rem hidden w-min items-center border border-red-200 bg-red-100 p-2 text-xs text-red-700 md:flex"
      ><div class="text-xs text-red-700 opacity-0 md:hidden">
        {{ 'widgets.widget.data.new' | translate }}
      </div>
      <div class="hidden text-xs text-red-700 md:block">
        {{ 'widgets.widget.data.new' | translate }}
      </div>
    </span>
    <span
      *ngIf="config.new"
      class="inline-flex h-4 w-4 items-center rounded-full border border-red-200 bg-red-100 p-0 text-xs text-red-700 md:hidden"
      pTooltip="{{ 'widgets.widget.data.new' | translate }}"
      tooltipPosition="top"
      ><div class="text-xs text-red-700 opacity-0 md:hidden">
        {{ 'widgets.widget.data.new' | translate }}
      </div>
    </span>
    <span
      *ngIf="config.needsAttention"
      [pTooltip]="config.warnings"
      class="inline-flex items-center md:flex"
      tooltipPosition="top">
      <i class="fa-regular fa-triangle-exclamation text-red-400 md:text-xl"></i>
    </span>
    <span
      *ngIf="config.bundleId > 0"
      [pTooltip]="'overview.bundle.status' | translate"
      class="inline-flex items-center md:flex"
      tooltipPosition="top">
      <i class="fa-regular fa-rectangle-list md:text-xl"></i>
    </span>
  </div>
</ng-template>

<ng-template #mainInfoComponent>
  <div
    *ngIf="hasToShowMainInfoComponent"
    class="flex w-full gap-2 bg-white px-4 py-2 lg:flex-row lg:justify-between"
    [ngClass]="{
      'w-auto flex-1': !hasToShowStatusComponent && !hasToShowActionsComponent && !hasToShowTaskComponent,
      'lg:flex-1': !isHalfWidth,
      'flex-col': hasToShowStatusComponent,
      'flex-row-reverse justify-between': !hasToShowStatusComponent && hasToShowActionsComponent
    }">
    <div class="order-1 inline w-full max-w-max items-center gap-2 leading-normal md:flex lg:order-none">
      <ng-container
        *ngIf="hasToShowMainInfoLabelsComponent"
        [ngTemplateOutlet]="mainInfoLabelsComponent"></ng-container>
      <div
        class="inline w-full"
        [ngClass]="{
          'inline-flex': config.confidential,
          'ml-2': hasToShowMainInfoLabelsComponent
        }">
        <span
          *ngIf="config.hd"
          class="rounded-border h-1-25rem mr-1 inline-flex items-center border border-red-400 bg-red-400 p-1 text-xs text-white"
          pTooltip="{{ 'decree.detail.informatie_hoogdringend_radio' | translate }}"
          tooltipPosition="top"
          >HD</span
        >
        <span
          *ngIf="config.yearNumber"
          class="rounded-border h-1-25rem mr-1 inline-flex items-center border border-gray-300 bg-gray-300 p-1 text-xs"
          >{{ config.yearNumber }}
        </span>
        <span class="inline">{{ config.title }}</span>
      </div>
    </div>
    <div
      *ngIf="hasToShowStatusComponent || hasToShowActionsComponent"
      class="flex justify-between gap-2"
      [ngClass]="{
        'justify-end': !hasToShowStatusComponent,
        'md:hidden': (hasToShowStatusComponent && hasToShowActionsComponent) || hasToShowTaskComponent,
        'lg:hidden': isHalfWidth,
        'lg:flex': !isHalfWidth
      }">
      <div
        *ngIf="hasToShowStatusComponent"
        class="order-none flex items-center lg:order-1 lg:flex"
        [ngClass]="{
          'md:hidden': hasToShowTaskComponent
        }">
        <ng-container [ngTemplateOutlet]="statusComponent"></ng-container>
      </div>
      <div
        *ngIf="hasToShowActionsComponent"
        class="items-center lg:order-2"
        [ngClass]="{
          flex: !hasToShowTaskComponent || !hasToShowStatusComponent,
          hidden: hasToShowTaskComponent,
          'md:hidden lg:flex': hasToShowTaskComponent
        }">
        <ng-container [ngTemplateOutlet]="actionsComponent"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #actionsComponent>
  <button
    (click)="handleEditListItem()"
    *ngIf="config.userCanEditItem"
    pButton
    class="p-button-sm p-button-link w-min"
    icon="fa-regular fa-pen-to-square"></button>
  <button
    (click)="handleRemoveListItem($event)"
    *ngIf="config.userCanDeleteItem"
    pButton
    class="p-button-sm p-button-link w-min"
    icon="fa-regular fa-trash-can"></button>
  <div
    *ngIf="
      config.showVerticalEllipsis &&
      config.verticalEllipsis?.menuItems &&
      config.verticalEllipsis?.menuItems?.length > 0
    "
    class="flex items-center">
    <app-tiered-menu-button
      (click)="$event.preventDefault(); $event.stopPropagation(); handleSelectVerticalEllipsisItem()"
      [menuItems]="config.verticalEllipsis?.menuItems"
      buttonClass="p-button-sm p-button-link w-min"
      iconLeft="fa-solid fa-ellipsis-vertical"
      textWhite="false">
    </app-tiered-menu-button>
  </div>
</ng-template>

<ng-template #documentsToggleComponent>
  <ng-container *ngIf="config.documents?.length">
    <div
      (click)="toggleDocumentsList($event)"
      class="flex max-w-full min-w-min flex-auto cursor-pointer items-center bg-white px-4 py-2">
      <button (click)="toggleDocumentsList($event)" class="p-button-link" icon="fa-regular fa-paperclip" pButton>
        <span class="flex items-center gap-2"
          >{{ config.documents?.length }} documenten
          <i [class]="showDocumentsList ? 'fa-regular fa-chevron-up' : 'fa-regular fa-chevron-down'"></i
        ></span>
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #openTasksComponent>
  <ng-container *ngIf="config.openTasks">
    <div class="flex max-w-full min-w-min flex-auto items-center bg-white px-4 py-2">
      <span class="flex items-center gap-2 text-red-400">
        <i class="fa-regular fa-list-check text-red-400"></i>
        Openstaande taken
      </span>
    </div>
  </ng-container>
</ng-template>

<ng-template #infoComponent>
  <div class="flex max-w-full min-w-min flex-auto flex-wrap bg-white">
    <div
      (click)="handleShowMore($event)"
      *ngIf="config.info?.length"
      class="flex cursor-auto items-center px-4 py-1"
      [ngClass]="{
        'flex-nowrap': !showMoreMeta,
        'cursor-pointer': overflowedItems().length
      }">
      <div
        #infoItems
        [ngClass]="{
          'h-8 overflow-hidden': !showMoreMeta
        }"
        class="min-h-2rem flex w-full flex-wrap items-start">
        <app-infobar-item
          *ngFor="let info of config.info; let i = index"
          [counter]="info.counter"
          [icon]="info.icon"
          [index]="i"
          [ngClass]="{
            'h-8!': showMoreMeta
          }"
          [prefix]="info.prefix"
          [className]="info.className"
          [tooltips]="info.tooltips"
          [value]="info.value"
          class="flex h-full shrink-0"></app-infobar-item>
      </div>
      <div class="flex h-8 items-center">
        <button
          (click)="handleShowMore($event)"
          *ngIf="overflowedItems().length || config.timeline"
          [label]="(showMoreMeta ? 'widgets.widget.data.less' : 'widgets.widget.data.more') | translate"
          class="p-button-link h-8"
          styleClass="h-8"
          pButton></button>
      </div>
    </div>
  </div>
  <ng-container [ngTemplateOutlet]="timelineComponent"></ng-container>
</ng-template>

<ng-template #timelineComponent>
  <div *ngIf="config.timeline && showMoreMeta" class="flex w-full flex-col bg-white px-4 py-1">
    <p-timeline [value]="config.timeline" class="w-full">
      <ng-template let-item pTemplate="content">
        <div class="timeline-header">
          {{ item.state.name | translate }}
        </div>
        <div class="timeline-content">
          <div class="text-gray-600">
            {{ item.state.name | translate }}
            {{ 'label.external.ws.workorder.information.requestedby' | translate }}
            <span class="font-bold text-gray-600">{{ item.actingUser }}</span>
            {{ 'calendar.repeat.on' | translate }}
            <span class="font-bold text-gray-600">{{
              item.timestamp | getFormattedDate: 'DD/MM/yyyy' : 'DD/MM/yyyy HH:mm:ss'
            }}</span>
          </div>
          <div class="text-gray-600">
            {{ item.additionalInfo }}
          </div>
        </div>
      </ng-template>
    </p-timeline>
  </div>
</ng-template>

<ng-template #labelsComponent>
  <div
    *ngIf="config.labels?.length"
    class="flex max-w-full min-w-min flex-1 flex-wrap items-center gap-2 bg-white px-4 py-1">
    <div *ngFor="let label of config.labels" class="inline-block">
      <p-chip [label]="label" styleClass="p-chip-xs p-chip-neutral"></p-chip>
    </div>
  </div>
</ng-template>

<ng-template #optionalInfoComponent>
  <div *ngIf="config.optionalInfo" class="flex max-w-full min-w-min flex-auto items-center bg-white px-4 py-1">
    <span [innerHTML]="config.optionalInfo"></span>
  </div>
</ng-template>

<ng-template #documentsList let-items="items">
  @if (items.length) {
    <div class="flex w-full flex-col gap-2 bg-white px-2 py-2">
      @for (item of items; track $index) {
        <!--CTODO: CHECK IF WORKS-->
        <app-document [document]="item"></app-document>

        <!-- <a
          (click)="$event.preventDefault(); $event.stopPropagation(); downloadFile(item)"
          *ngFor="let item of items"
          class="rounded-border flex h-8 w-full items-center gap-2 px-2 hover:bg-gray-200">
          <i [class]="item.icon"></i>
          <span class="flex items-center gap-2">{{ item.name }}</span>
          <i class="p-button-link fa-regular fa-arrow-down-to-line text-blue-400"></i>
        </a> -->
      }
    </div>
  }
</ng-template>
